import axios from "axios";

export function getPeopleFlow(data) {
    return axios({
        method: 'get',
        url: '/user/smartPeopleFlow',
        params: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    });
}

export function getHistogramData() {
    return axios({
        url: "/user/smartPeopleFlow/statistics/mouth",
        method: "get",
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    });
}

export function getMothPassData(data) {
    return axios({
        url: "/user/passRecord/statistics/mouth",
        method: "get",
        params: data,
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
    });
}
